<!--导入数据-->

<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="180px"
            size="mini"
        >

            <el-form-item label="下载模板" style="margin-top: 15px;">
                <a :href="getFilePath()" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“{{tipTxt}}”</a>
            </el-form-item>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed="handExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div
                        class="el-upload__text"
                        style="font-size: 12px;margin-top: 5px;"
                    >
                        只能上传.xls/.xlsx文件
                    </div>
                </el-upload>
            </div>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product.js'
    export default {
        name: 'importData',
        data() {
            return {
                asin: '',
                loading: false,
                list_id: '',
                functionStr: '',
                fileTxt: '',
                tipTxt: '',
                title: '',
                state: '',
                visible: false,
                files: [],
                formData: {
                    asin: ''
                },
                date: "",
                rules: {
                }
            };
        },
        methods: {
            getFilePath(){
              return `/export/${this.fileTxt}`
            },
            handleUpload(raw) {
                this.files.push(raw.file);
            },
            handExceed(files, fileList) {
                this.$message({
                    type: "warning",
                    message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
                });
                return;
            },
            handFileSuccess() {
                this.files = [];
                this.$refs.upload.clearFiles();
            },
            handleRemove(file, fileList) {
                this.files = fileList;
            },
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                        if (this.files.length == 0) {
                            this.$message.warning(`当前限制只能上传选择 1 个文件`);
                            return;
                        }
                        let file = new FormData();
                        file.append("file", this.files[0]);
                        file.append("list_id", this.list_id);
                        this.state && file.append("state", this.state);

                        this.loading = true;
                        api[this.functionStr](file).then(res => {
                            if (res.code === 0) {
                                this.loading = false;
                                this.$message({
                                    type: "success",
                                    message: res.data
                                });
                                this.formData = {};
                                this.handleClose(true);
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                            .catch(() => {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message:
                                        "网络出现问题，请查看数据是否添加完成！"
                                });
                            });
                    } else {
                        this.loading = false;
                        this.$message({
                            type: "error",
                            message: "请填写相应内容！"
                        });
                    }
                });
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.formData = {};
                this.handFileSuccess();
                this.date = "";
                this.$refs["formData"].resetFields();
                this.loading = false;
                this.$emit("close-callback", isshow);
            }
        }
    };
</script>
<style type="text/scss" lang="scss" scoped>
    .download {
        display: flex;
        justify-content: center;
    }
</style>
